import template from 'text!./Table.html';

export default [function () {
    return {
        restrict: 'E',
        scope: {
            schedule: '&'
        },
        template: template
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/schedules/scheduleTypes/readonly/Table/Table.js
// module id = 294
// module chunks = 0